<template>
    <div class="pt-2 pl-2">
        <v-row no-gutters>
            <v-col class="pr-1" :cols="accountingLinesLocked ? 7 : 6">
                <div class="default_card_wm pt-2">
                    <DocumentMenu
                        v-model:selectedText="selectedText"
                        :MenuOptions="documentMenuOptions"
                        @back="back()"
                        @zoom-out="zoomManager.zoomOut()"
                        @reset-zoom="zoomManager.resetZoom()"
                        @zoom-in="zoomManager.zoomIn()"
                        @ocr-changed="onOCRChanged()"
                        @rotate-left="
                            documentPdfRotation = rotate('left', zoomManager, documentPdfRotation)
                        "
                        @rotate-right="
                            documentPdfRotation = rotate('right', zoomManager, documentPdfRotation)
                        "
                        @clear-selected-text="emptySelectedText()"
                        @edit="accountingLinesLockedDialog = true"
                        @display-file="
                            showAccountingLines = false;
                            displayActivity = false;
                        "
                        @display-accounting-line="
                            showAccountingLines = true;
                            displayActivity = false;
                        "
                        @download="startDownloadFile()"
                        @cut="cutDocumentDialog = true"
                        @analyse="analyseDocumentDialog = true"
                        @activity="
                            displayActivity = true;
                            showAccountingLines = false;
                        "
                        @delete="
                            orphelinDepreciationAcrId?.length
                                ? (deleteOrphelinDocumentDialog = true)
                                : (deleteDocumentDialog = true)
                        "
                    />
                    <v-row no-gutters class="align-center">
                        <!--
                        <v-col class="d-flex" cols="8">
                            <v-btn-back
                                @click.stop="back()"
                                v-if="mode !== 'GeneralLedger' && mode !== 'Reconciliation' && goBackHistory"
                                data-cy="document-back"
                                class="mt-2"
                            />
                            <template v-if="!showAccountingLines && !displayActivity">
                                <v-btn-icon
                                    icon="$oss-zoom-out"
                                    v-if="!isPDF"
                                    :disabled="zoomManager.disableZoomOut()"
                                    class="btn mr-1"
                                    @click.stop="zoomManager.zoomOut()"
                                />
                                <v-btn-icon
                                    icon="$oss-focus"
                                    v-if="!isPDF"
                                    :disabled="zoomManager.disableResetZoom()"
                                    class="btn mx-1"
                                    @click.stop="zoomManager.resetZoom()"
                                />
                                <v-btn-icon
                                    icon="$oss-zoom-in"
                                    v-if="!isPDF"
                                    :disabled="zoomManager.disableZoomIn()"
                                    class="btn ml-1"
                                    @click.stop="zoomManager.zoomIn()"
                                />
                                <v-btn-icon
                                    icon="$oss-eye"
                                    :disabled="zoomManager.disableResetZoom()"
                                    class="btn ml-1"
                                    :color="showOCR ? 'primary' : 'secondary'"
                                    :loading="ocrLoading"
                                    @click.stop="onOCRChanged()"
                                    v-if="document.signedUrlOCR"
                                />
                                <v-btn-icon
                                    class="my-0 mr-1"
                                    @click.stop="
                                        documentPdfRotation = rotate(
                                            'left',
                                            zoomManager,
                                            documentPdfRotation,
                                        )
                                    "
                                    icon="$fa-undo"
                                >
                                </v-btn-icon>
                                <v-btn-icon
                                    class="my-0"
                                    @click.stop="
                                        documentPdfRotation = rotate(
                                            'right',
                                            zoomManager,
                                            documentPdfRotation,
                                        )
                                    "
                                    icon="$fa-redo"
                                >
                                </v-btn-icon>
                                <v-text-field-filled
                                    v-model="selectedText"
                                    v-show="selectedText"
                                    id="selectedText"
                                    hide-details
                                    class="ml-2 small-prepend-icon"
                                    append-inner-icon="$oss-close"
                                    block
                                    density="compact"
                                    @click:append-inner="emptySelectedText"
                                />
                            </template>
                        </v-col>
                        <!-- <v-spacer></v-spacer> -->
                        <!--
                        <v-col class="d-flex justify-end align-center" cols="4">
                            <v-btn-icon
                                icon="$oss-edit"
                                v-if="showAccountingLines && !isIncomingOutgoingPayment"
                                @click="accountingLinesLockedDialog = true"
                            />
                            <!-- <v-btn-icon
                                icon="$oss-help"
                                elevation="0"
                                @click="startTuto()"
                                v-if="mode !== 'GeneralLedger'"
                            /> -->
                        <!--
                            <v-btn-toggle
                                v-if="
                                    !isIncomingOutgoingPayment &&
                                    document.status === 'VALIDATED' &&
                                    document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                "
                                v-model="showAccountingLines"
                                class="ml-1"
                                rounded="xl"
                            >
                                <v-btn-icon
                                    icon="$oss-file"
                                    :value="0"
                                    @click="
                                        showAccountingLines = false;
                                        displayActivity = false;
                                    "
                                    class="d-flex align-center justify-center pb-2"
                                />
                                <v-btn-icon
                                    icon="$oss-accounting-lines"
                                    :value="1"
                                    @click="
                                        showAccountingLines = true;
                                        displayActivity = false;
                                    "
                                    class="d-flex align-center justify-center pb-2"
                                />
                            </v-btn-toggle>
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon icon="$dots_vertical" v-bind="props" />
                                </template>
                                <v-list nav rounded="xl">
                                    <v-list-item
                                        @click="
                                            showAccountingLines = false;
                                            displayActivity = false;
                                        "
                                        v-if="
                                            isAccountingUser &&
                                            document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        "
                                    >
                                        <v-list-item-title>Document</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-file</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="
                                            showAccountingLines = true;
                                            displayActivity = false;
                                        "
                                        v-if="
                                            isAccountingUser &&
                                            document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        "
                                    >
                                        <v-list-item-title>{{
                                            isIncomingOutgoingPayment
                                                ? "Détail"
                                                : "&#xc9;critures comptables"
                                        }}</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-accounting-lines</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="
                                            !showAccountingLines &&
                                            !displayActivity &&
                                            !!document.original
                                        "
                                        @click="startDownloadFile"
                                    >
                                        <v-list-item-title>Télécharger</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-download</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="accountingLinesLockedDialog = true"
                                        v-if="
                                            !isIncomingOutgoingPayment &&
                                            document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        "
                                    >
                                        <v-list-item-title
                                            >&#xc9;critures manuelles</v-list-item-title
                                        >
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-edit</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="analyseDocumentDialog = true"
                                        v-if="restartAnalysis"
                                    >
                                        <v-list-item-title>Relancer l'analyse</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-scan</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="
                                            displayActivity = true;
                                            showAccountingLines = false;
                                        "
                                        v-if="isAccountingUser"
                                    >
                                        <v-list-item-title>Afficher l'activité</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-activity</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="pb-2" />

                                    <v-tooltip
                                        v-if="
                                            editionMessage &&
                                            editionMessage.length &&
                                            orphelinDepreciationAcrId &&
                                            orphelinDepreciationAcrId.length
                                        "
                                        location="bottom"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <div style="height: fit-content" v-bind="props">
                                                <v-list-item
                                                    @click="deleteOrphelinDocumentDialog = true"
                                                    :disabled="disabledDelete"
                                                    color="error"
                                                    :active="!disabledDelete"
                                                >
                                                    <v-list-item-title>Supprimer</v-list-item-title>
                                                    <template v-slot:append>
                                                        <v-icon size="small">$oss-trash</v-icon>
                                                    </template>
                                                </v-list-item>
                                            </div>
                                        </template>
                                        <div v-html="editionMessage" />
                                    </v-tooltip>

                                    <v-tooltip
                                        v-else-if="editionMessage && editionMessage.length"
                                        location="bottom"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <div style="height: fit-content" v-bind="props">
                                                <v-list-item
                                                    @click="deleteDocumentDialog = true"
                                                    :disabled="disabledDelete"
                                                    color="error"
                                                    :active="!disabledDelete"
                                                >
                                                    <v-list-item-title>Supprimer</v-list-item-title>
                                                    <template v-slot:append>
                                                        <v-icon size="small">$oss-trash</v-icon>
                                                    </template>
                                                </v-list-item>
                                            </div>
                                        </template>
                                        <div v-html="editionMessage" />
                                    </v-tooltip>

                                    <v-list-item
                                        v-else
                                        @click="deleteDocumentDialog = true"
                                        :disabled="disabledDelete"
                                        color="error"
                                        :active="!disabledDelete"
                                    >
                                        <v-list-item-title>Supprimer</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-trash</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>-->
                        <!-- <v-col class="d-flex justify-end" v-else>
                            <v-btn
                                @click="accountingLinesLockedDialog = true"
                                icon
                                class="mx-1"
                                color="primary"
                            >
                                <v-icon  size="small">$oss-edit</v-icon>
                            </v-btn>
                            <v-btn
                                @click="showAccountingLines = false"
                                icon
                                class="mx-1"
                                color="primary"
                            >
                                <v-icon  size="small">$oss-close</v-icon>
                            </v-btn>
                        </v-col> -->
                        <template v-if="!displayActivity && !showAccountingLines">
                            <v-col
                                cols="12"
                                style="max-height: 86vh; overflow-y: auto"
                                v-if="isImage"
                                id="InvoiceDocumentValidation"
                            >
                                <div
                                    style="
                                        position: relative;
                                        width: 100%;
                                        height: 0;
                                        padding: 0;
                                        padding-bottom: 141.4516129032258%;
                                        margin-bottom: 50px;
                                    "
                                >
                                    <svg
                                        id="svg-document-validation"
                                        v-if="document"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="100%"
                                        :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                        style="
                                            position: absolute;
                                            width: 100%;
                                            left: 0;
                                            top: 0;
                                            background: #fff;
                                        "
                                    >
                                        <g>
                                            <image
                                                id="svg-image-document-validation"
                                                :xlink:href="document.signedUrl"
                                                x="0"
                                                y="0"
                                                :height="`${imageHeight}px`"
                                                :width="`${imageWidth}px`"
                                            />
                                            <template v-if="!showOCR">
                                                <template
                                                    v-for="(variant, index) in svgVariants"
                                                    :key="`coord-${document.id}-${index}`"
                                                >
                                                    <template
                                                        v-for="(
                                                            coord, index2
                                                        ) in variant.coordinates"
                                                        :key="`coord-${document.id}-${index}-${index2}`"
                                                    >
                                                        <polygon
                                                            :ref="`variants-${index}-${index2}`"
                                                            :points="getPoints(coord)"
                                                            :style="
                                                                variant.active
                                                                    ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                                    : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                            "
                                                            @click.stop="
                                                                variant.active
                                                                    ? ''
                                                                    : showCorrespondingField({
                                                                          variant,
                                                                          currentIndex: index,
                                                                          copyIndex: index2,
                                                                      })
                                                            "
                                                            :class="
                                                                variant.focus ? 'highlighted' : ''
                                                            "
                                                        />
                                                    </template>
                                                </template>
                                            </template>
                                            <template
                                                v-else-if="
                                                    showOCR &&
                                                    ocr &&
                                                    ocr.sentences &&
                                                    ocr.sentences.length
                                                "
                                            >
                                                <template
                                                    v-for="(sentence, sIndex) in ocr.sentences"
                                                    :key="`sentence-${sIndex}`"
                                                >
                                                    <template
                                                        v-for="(token, tIndex) in sentence.tokens"
                                                        :key="`sentence-${sIndex}-token-${tIndex}`"
                                                    >
                                                        <polygon
                                                            :ref="`sentence-${sIndex}-token-${tIndex}`"
                                                            :points="getTokenPoints(token)"
                                                            :style="getTokenStyle(token)"
                                                            @mouseover="token.high = true"
                                                            @mouseout="token.high = false"
                                                            @click.stop="onClickToken(token)"
                                                        />
                                                    </template>
                                                </template>
                                            </template>
                                        </g>
                                    </svg>
                                </div>
                            </v-col>
                            <v-col
                                cols="12"
                                v-else-if="isPDF"
                                class="d-flex justify-center"
                                style="height: calc(100vh - 130px); overflow-y: auto"
                                id="InvoiceDocumentValidation"
                            >
                                <ossPdf
                                    :documentId="document.id"
                                    :rotation="documentPdfRotation"
                                    @update:rotation="updateRotation"
                                />
                            </v-col>
                        </template>

                        <v-col
                            cols="12"
                            style="height: calc(100vh - 130px); overflow-y: auto"
                            v-if="displayActivity && !showAccountingLines"
                        >
                            <UsersActivitiesHistory :documentId="document.id">
                            </UsersActivitiesHistory> </v-col
                        ><v-col
                            cols="12"
                            style="height: calc(100vh - 130px); overflow-y: auto"
                            v-if="!displayActivity && showAccountingLines"
                        >
                            <accounting-item-static
                                :companyId="companyId"
                                :documentId="document.id"
                                mode="Embedded"
                            />
                        </v-col>
                    </v-row>
                </div>
                <v-list v-if="associatedFields.show" :style="svgPosition">
                    <v-list-item
                        v-for="(field, key, index) in associatedFields.fields"
                        :key="`field-${document.id}-${key}-${index}`"
                        @click="onFieldAssociation(field, key)"
                        class="oss-list-item"
                    >
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col :cols="accountingLinesLocked ? 5 : 6" class="my-0 pl-1">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                    "
                    class="default_card_wm elevation-0 rounded-l-2 fill-height"
                    id="FormDocumentValidation"
                >
                    <v-card-text class="px-0" style="height: calc(100vh - 140px); overflow-y: auto">
                        <v-window v-model="windowStep" touchless>
                            <v-window-item :value="0">
                                <v-form ref="form" v-model="valid" v-if="form.date">
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-list single-line class="pt-0" density="compact">
                                                <v-list-item
                                                    :ripple="false"
                                                    class="oss-list-item mb-2"
                                                    color="success"
                                                >
                                                    <v-list-item-title class="body-1">
                                                        <v-row no-gutters>
                                                            <v-col
                                                                cols="3"
                                                                class="d-flex align-center"
                                                                style="
                                                                    border-right: 1px #ededed solid;
                                                                "
                                                            >
                                                                <b>Statut</b>
                                                            </v-col>
                                                            <v-col
                                                                cols="9"
                                                                class="d-flex align-center pl-2"
                                                            >
                                                                {{ documentStatus }}
                                                                <v-spacer />
                                                                <!-- <v-btn
                                                                        color="primary"
                                                                        rounded size="small"
                                                                        elevation="0"
                                                                        v-if="activateReconciliation && reconciliationCallToAction"
                                                                        :disabled="disabledCallToAction"
                                                                        @click="openReconciliation()"
                                                                    >{{ reconciliationCallToAction }}</v-btn> -->
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item-title></v-list-item
                                                >
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" id="ThirdCompanyDocumentValidation">
                                            <v-card
                                                class="default_card_wm mx-auto pt-2"
                                                style="
                                                    background: #fff !important;
                                                    border: solid rgba(0, 0, 0, 0.12) 1px;
                                                    box-shadow: none;
                                                "
                                                data-cy="DocumentValidation-societe"
                                            >
                                                <v-card-title
                                                    primary-title
                                                    v-if="!consumer"
                                                    class="py-0"
                                                >
                                                    <v-row no-gutters>
                                                        <v-col cols="11">
                                                            <template
                                                                v-if="
                                                                    document.thirdPartyCompany &&
                                                                    document.thirdPartyCompany.id
                                                                "
                                                            >
                                                                {{
                                                                    thirdPartyType() +
                                                                    ": " +
                                                                    (document.thirdPartyCompany
                                                                        ? document.thirdPartyCompany
                                                                              .name
                                                                        : "")
                                                                }}
                                                            </template>
                                                            <template v-else>
                                                                <span
                                                                    v-if="
                                                                        isBankTransactionReceipt ||
                                                                        isIncomingOutgoingPayment ||
                                                                        isExpenseReportDocument
                                                                    "
                                                                >
                                                                    Sélectionnez une société
                                                                    (Facultatif)
                                                                </span>
                                                                <span v-else class="text-error">
                                                                    Sélectionnez une société
                                                                </span>
                                                            </template>
                                                        </v-col>
                                                        <v-col cols="1" class="d-flex justify-end">
                                                            <v-btn-icon
                                                                icon="$oss-edit"
                                                                elevation="0"
                                                                class="my-0"
                                                                @click="windowStep = 1"
                                                                v-if="!consumer"
                                                                data-cy="DocumentValidation-fournisseur"
                                                                size="small"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                                <v-card-text class="text-left">
                                                    <v-row no-gutters>
                                                        <v-col cols="8">
                                                            <div
                                                                v-if="
                                                                    !consumer &&
                                                                    document.thirdPartyCompany &&
                                                                    document.thirdPartyCompany.siret
                                                                "
                                                            >
                                                                Siret :
                                                                {{
                                                                    getSiretValue(
                                                                        document.thirdPartyCompany
                                                                            .siret,
                                                                    )
                                                                }}
                                                            </div>
                                                            <span v-if="fullAddress">
                                                                Adresse : {{ fullAddress }}
                                                            </span>
                                                        </v-col>
                                                        <v-col cols="4" class="d-flex justify-end">
                                                            <v-switch
                                                                v-model="consumer"
                                                                class="my-0"
                                                                :label="'Particulier'"
                                                                hide-details
                                                                v-if="
                                                                    document.type ===
                                                                    'SALES_INVOICE'
                                                                "
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            v-if="
                                                                document?.thirdPartyCompany &&
                                                                !document?.thirdPartyCompany
                                                                    .isActive
                                                            "
                                                        >
                                                            <p class="text-red">
                                                                Cette société est inactive
                                                            </p>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pt-2">
                                        <v-col cols="12" id="NameDocumentValidation">
                                            <v-text-field-filled
                                                v-model="document.displayName"
                                                label="Nom du document"
                                                hide-details
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        class="pt-2"
                                        v-if="
                                            activateTagguing &&
                                            document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        "
                                    >
                                        <v-col cols="12">
                                            <v-list-item :ripple="false" class="oss-list-item mb-2">
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <FreeTag
                                                                :companyTags="allCompanyTags"
                                                                :document="inDocument"
                                                                :splitUserPartitions="true"
                                                                @onTagsChanged="
                                                                    startToBeDoneIfNecessary
                                                                "
                                                            />
                                                        </v-col>
                                                    </v-row> </v-list-item-title
                                            ></v-list-item>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pt-2">
                                        <v-col cols="6" class="pr-1" id="TypeDocumentValidation">
                                            <v-select-filled
                                                :items="documentTypes"
                                                item-value="value"
                                                label="Type"
                                                style="margin: 0 auto"
                                                @update:model-value="
                                                    onTypeChange(
                                                        $event.toUpperCase().replace(' ', '_'),
                                                    )
                                                "
                                                hide-details
                                                :model-value="document.type"
                                                :item-title="(item) => item.label"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            v-if="
                                                document.type === 'CURRENT_ACCOUNT' ||
                                                document.type === 'OPERATOR_ACCOUNT'
                                            "
                                            class="pt-2"
                                        >
                                            <v-select-filled
                                                :items="currentAccountUsers"
                                                :item-title="getUserDisplayName"
                                                item-value="id"
                                                label="Associé"
                                                style="margin: 0 auto"
                                                v-model="currentAccountUser"
                                                return-object
                                                hide-details
                                                :rules="currentAccountUserRules"
                                                :error="!checkCurrentAccountUser"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col
                                            class="d-flex align-center justify-end px-1"
                                            id="CreditNoteDocumentValidation"
                                            data-cy="DocumentValidation-credit"
                                        >
                                            <v-switch
                                                hide-details
                                                v-model="document.creditNote"
                                                :label="'Avoir'"
                                                class="my-0"
                                            />
                                        </v-col>
                                    </v-row>
                                    <!--<v-row no-gutters class="pt-2" v-if="document.type === 'PURCHASE_INVOICE'">
                                            <v-col cols="12" id="NameDocumentValidation">
                                                 <v-select-filled
                                                    v-model="document.thirdPartyAccountableAccount"
                                                    :items="thirdPartyAccountableAccounts"

                                                    item-text="description"
                                                    dense
                                                    return-object
                                                    label="Third party Accountable account"
                                                    hide-details
                                                ></v-select-filled>
                                                <AccountableAccountVue
                                                    v-model="document.thirdPartyAccountableAccount"
                                                    :inputStyle="'padding: 0px; margin: 0px;'"
                                                    :companyId="companyId"
                                                    :showSuggestion="false"
                                                    :label="'Contre partie'"
                                                    :showDescription="true"
                                                    :showValidation="false"
                                                    :mandatory="false"
                                                    :hideDetails="true"
                                                    :needValidation="false"
                                                    :editAccountableAccount="true"
                                                    @close="closeAccountableAccount"
                                                ></AccountableAccountVue>
                                            </v-col>
                                        </v-row> -->
                                    <v-row no-gutters class="pt-2" id="DatesDocumentValidation">
                                        <v-col class="pr-1">
                                            <v-combobox-filled
                                                v-model="formattedDate"
                                                :color="
                                                    form.date && form.date.validated ? '' : 'red'
                                                "
                                                :items="dateList"
                                                :error="!form.date || !form.date.validated"
                                                class="small-prepend-icon"
                                                @keyup.enter="
                                                    onDateChange(form.date, 'date', $event)
                                                "
                                                @mouseover="highlightField(form.date, true)"
                                                @mouseout="highlightField(form.date, false)"
                                                @update:search="formattedDate = $event"
                                                required
                                                dense
                                                hide-details
                                            >
                                                <template v-slot:prepend-inner>
                                                    <v-icon
                                                        style="z-index: 1"
                                                        class="ml-2 mt-1"
                                                        @click.stop="dateDialog = !dateDialog"
                                                        >$oss-calendar</v-icon
                                                    >
                                                </template>
                                                <template v-slot:label>
                                                    <div class="ml-3">
                                                        Date du document
                                                        <span v-if="confidence(form.date)">
                                                            (
                                                            <span
                                                                :class="
                                                                    confidence(form.date) > 80
                                                                        ? ''
                                                                        : 'text-red'
                                                                "
                                                                >{{
                                                                    `${confidence(form.date)}%`
                                                                }}</span
                                                            >)
                                                        </span>
                                                    </div>
                                                </template>
                                            </v-combobox-filled>
                                        </v-col>
                                        <v-col cols="1" class="d-flex justify-start">
                                            <v-btn-icon
                                                :icon="
                                                    form.date && form.date.validated
                                                        ? '$oss-circle-check'
                                                        : '$oss-circle-uncheck'
                                                "
                                                :color="
                                                    form.date && form.date.validated
                                                        ? 'primary'
                                                        : 'red'
                                                "
                                                @click="validateDateField(form.date, 'date')"
                                                size="small"
                                            >
                                            </v-btn-icon>
                                        </v-col>
                                        <v-col v-if="dueDateEnable" class="px-1">
                                            <oss-date-picker-filled
                                                v-model="dueDate"
                                                :hide-details="true"
                                                :label="$t('shared.dueDate')"
                                                @change-date="onDueDateChanged"
                                                :mandatory="false"
                                                :textFieldReadOnly="false"
                                                :prefixDataCy="'DocumentValidation-dueDate-'"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pt-2">
                                        <v-col v-if="documentIsInAccountingClosing" class="px-1">
                                            <oss-date-picker-filled
                                                v-model="accountingDate"
                                                :hide-details="true"
                                                :label="$t('shared.accountingDate')"
                                                :mandatory="true"
                                                :textFieldReadOnly="false"
                                                :prefixDataCy="'DocumentValidation-accountingDate-'"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pt-2">
                                        <v-col cols="11" class="pr-1">
                                            <v-combobox-filled
                                                v-model="invoiceNumber"
                                                :items="invoiceNumberList"
                                                :color="
                                                    form['invoiceNumber'].validated ? '' : 'red'
                                                "
                                                :error="!form['invoiceNumber'].validated"
                                                @keyup.enter="
                                                    onDateChange(
                                                        form['invoiceNumber'],
                                                        'invoiceNumber',
                                                        $event,
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(form['invoiceNumber'], true)
                                                "
                                                @mouseout="
                                                    highlightField(form['invoiceNumber'], false)
                                                "
                                                @update:search="invoiceNumber = $event"
                                                :mandatory="isInvoiceNumberManadatory"
                                                dense
                                                :hide-details="true"
                                                data-cy="DocupmentValidation-numInvoice"
                                            >
                                                <template v-slot:prepend-inner>
                                                    <div class="ml-1" />
                                                </template>
                                                <template v-slot:label>
                                                    <div class="ml-3">
                                                        Numéro de facture
                                                        <span
                                                            v-if="confidence(form['invoiceNumber'])"
                                                        >
                                                            (<span
                                                                :class="
                                                                    confidence(
                                                                        form['invoiceNumber'],
                                                                    ) > 80
                                                                        ? ''
                                                                        : 'text-red'
                                                                "
                                                            >
                                                                {{
                                                                    `${confidence(
                                                                        form["invoiceNumber"],
                                                                    )}%`
                                                                }} </span
                                                            >)
                                                        </span>
                                                    </div>
                                                </template>
                                            </v-combobox-filled>
                                        </v-col>
                                        <v-col cols="1" class="d-flex justify-start">
                                            <v-btn-icon
                                                :icon="
                                                    form['invoiceNumber'] &&
                                                    form['invoiceNumber'].validated
                                                        ? '$oss-circle-check'
                                                        : '$oss-circle-uncheck'
                                                "
                                                :color="
                                                    form['invoiceNumber'].validated
                                                        ? 'primary'
                                                        : 'red'
                                                "
                                                @click="
                                                    form['invoiceNumber'].validated =
                                                        !form['invoiceNumber'].validated
                                                "
                                                size="small"
                                            >
                                            </v-btn-icon>
                                        </v-col>
                                        <v-col
                                            :cols="
                                                stockOperation && stockOperation.stockProductId
                                                    ? 8
                                                    : 12
                                            "
                                            class="pt-2"
                                            v-if="!multiAccountableAccount"
                                        >
                                            <AccountableAccountVue
                                                :companyId="companyId"
                                                :document="document"
                                                :inputStyle="'padding: 0px; margin: 0px;'"
                                                :showSuggestion="false"
                                                :showDescription="true"
                                                :showValidation="false"
                                                :mandatory="false"
                                                :hideDetails="true"
                                                :editAccountableAccount="true"
                                                :addInvoiceProduct="enableStock"
                                                @close="closeAccountableAccount"
                                                @select-accountableAccount="
                                                    selectAccountableAccount
                                                "
                                                innerId="AccountableAccountDocumentValidation"
                                                id="AccountableAccountDocumentValidation"
                                                data-cy="DocumentValidation-AccountableAccountVue"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="4"
                                            class="pl-2 pt-2"
                                            v-if="
                                                !multiAccountableAccount &&
                                                stockOperation &&
                                                stockOperation.stockProductId
                                            "
                                        >
                                            <oss-text-field-filled
                                                :hide-details="true"
                                                label="Quantité de produit"
                                                class="ml-2 righted-input"
                                                v-model="stockOperation.productQuantity"
                                                :rules="[
                                                    (v) => v > 0 || $t('settings.positiveNumber'),
                                                ]"
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <template v-if="stockOperation && stockOperation.data">
                                        <template
                                            v-for="(item, index) in stockOperation.data.quantities"
                                        >
                                            <v-row no-gutters class="pt-2" v-if="index % 4 === 0">
                                                <template v-for="i in 4">
                                                    <v-col
                                                        cols="3"
                                                        :key="index + i"
                                                        v-if="
                                                            stockOperation.data.quantities[
                                                                index + i - 1
                                                            ]
                                                        "
                                                    >
                                                        <oss-text-field-filled
                                                            :hide-details="true"
                                                            :label="
                                                                stockOperation.data.quantities[
                                                                    index + i - 1
                                                                ].quantityName
                                                            "
                                                            :class="
                                                                (i > 1 ? 'ml-2 ' : '') +
                                                                'righted-input oss-dark'
                                                            "
                                                            v-model="
                                                                stockOperation.data.quantities[
                                                                    index + i - 1
                                                                ].quantity
                                                            "
                                                            :rules="[
                                                                (v) =>
                                                                    v >= 0 ||
                                                                    $t('settings.positiveNumber'),
                                                            ]"
                                                        >
                                                        </oss-text-field-filled>
                                                    </v-col>
                                                </template>
                                            </v-row>
                                        </template>
                                    </template>
                                    <v-row no-gutters class="py-2 pt-5">
                                        <v-col
                                            cols="1"
                                            class="d-flex align-center flex-grow-1 flex-shrink-0"
                                            style="max-width: 100%"
                                        >
                                            {{
                                                subjectToVAT
                                                    ? document.type === "SALES_INVOICE"
                                                        ? "TVA et comptes de charges"
                                                        : "TVA"
                                                    : "Montant"
                                            }}
                                        </v-col>
                                        <v-col
                                            cols="11"
                                            class="d-flex align-center flex-grow-0 flex-shrink-1"
                                        >
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pb-5">
                                        <v-col
                                            cols="4"
                                            class="d-flex align-center pl-1"
                                            v-if="subjectToVAT"
                                            id="MultiVATDocumentValidation"
                                        >
                                            <v-switch
                                                v-model="multiVat"
                                                label="Multi TVA"
                                                hide-details
                                                :disabled="disabledMultiVat"
                                                class="my-0 pl-2"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            class="d-flex align-center pl-1"
                                            id="MultiAccountableAccountDocumentValidation"
                                        >
                                            <v-switch
                                                v-model="multiAccountableAccount"
                                                label="Multi comptes comptable"
                                                hide-details
                                                class="my-0"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="subjectToVAT ? '2' : '6'"
                                            class="d-flex align-center justify-end"
                                            v-if="multiAccountableAccount || multiVat"
                                        >
                                            <v-btn
                                                icon="$add"
                                                size="x-small"
                                                @click="addNewSubAmount()"
                                            >
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <template v-if="multiVat || multiAccountableAccount">
                                        <v-row
                                            no-gutters
                                            v-for="(subAmount, index) in form.subAmounts"
                                            :key="index"
                                            class="subAmountLine pt-1"
                                        >
                                            <v-col cols="12">{{
                                                subAmount.sign === -1 ? "Remise" : ""
                                            }}</v-col>
                                            <v-col cols="11">
                                                <v-row no-gutters>
                                                    <v-col
                                                        class="py-1 pr-1"
                                                        :cols="
                                                            !multiVat
                                                                ? subAmount.stockOperation &&
                                                                  subAmount.stockOperation
                                                                      .stockProductId
                                                                    ? '4'
                                                                    : '6'
                                                                : ''
                                                        "
                                                    >
                                                        <oss-text-field-filled
                                                            regular
                                                            dense
                                                            :hide-details="true"
                                                            @update:model-value="
                                                                $nextTick(() =>
                                                                    onMetadataChange_amountData(
                                                                        subAmount,
                                                                        'netAmount',
                                                                    ),
                                                                )
                                                            "
                                                            @mouseover="
                                                                highlightField(
                                                                    subAmount.netAmount,
                                                                    true,
                                                                )
                                                            "
                                                            @mouseout="
                                                                highlightField(
                                                                    subAmount.netAmount,
                                                                    false,
                                                                )
                                                            "
                                                            :color="
                                                                priceTextColor_amountData(
                                                                    subAmount,
                                                                    false,
                                                                )
                                                            "
                                                            v-model="subAmount.netAmount.value"
                                                        >
                                                            <template v-slot:label>
                                                                HT {{ index + 1 }}
                                                                <span
                                                                    v-if="
                                                                        confidence(
                                                                            subAmount.netAmount,
                                                                        )
                                                                    "
                                                                >
                                                                    (<span
                                                                        :class="
                                                                            confidence(
                                                                                subAmount.netAmount,
                                                                            ) > 80
                                                                                ? ''
                                                                                : 'text-red'
                                                                        "
                                                                    >
                                                                        {{
                                                                            `${confidence(
                                                                                subAmount.netAmount,
                                                                            )}%`
                                                                        }} </span
                                                                    >)
                                                                </span>
                                                            </template>
                                                        </oss-text-field-filled>
                                                    </v-col>
                                                    <v-col
                                                        class="py-1 pr-1"
                                                        cols="3"
                                                        v-if="multiVat"
                                                    >
                                                        <oss-text-field-filled
                                                            regular
                                                            dense
                                                            :hide-details="true"
                                                            @update:model-value="
                                                                $nextTick(() =>
                                                                    onMetadataChange_amountData(
                                                                        subAmount,
                                                                        'vatAmount',
                                                                    ),
                                                                )
                                                            "
                                                            @mouseover="
                                                                highlightField(
                                                                    subAmount.vatAmount,
                                                                    true,
                                                                )
                                                            "
                                                            @mouseout="
                                                                highlightField(
                                                                    subAmount.vatAmount,
                                                                    false,
                                                                )
                                                            "
                                                            :color="
                                                                priceTextColor_amountData(
                                                                    subAmount,
                                                                    false,
                                                                )
                                                            "
                                                            v-model="subAmount.vatAmount.value"
                                                        >
                                                            <template v-slot:label>
                                                                TVA {{ index + 1 }}
                                                                <span
                                                                    v-if="
                                                                        confidence(
                                                                            subAmount.vatAmount,
                                                                        )
                                                                    "
                                                                >
                                                                    (
                                                                    <span
                                                                        :class="
                                                                            confidence(
                                                                                subAmount.vatAmount,
                                                                            ) > 80
                                                                                ? ''
                                                                                : 'text-red'
                                                                        "
                                                                        >{{
                                                                            `${confidence(
                                                                                subAmount.vatAmount,
                                                                            )}%`
                                                                        }}</span
                                                                    >)
                                                                </span>
                                                            </template>
                                                        </oss-text-field-filled>
                                                    </v-col>
                                                    <v-col
                                                        class="py-1 pr-1"
                                                        cols="3"
                                                        v-if="multiVat"
                                                    >
                                                        <oss-text-field-filled
                                                            regular
                                                            dense
                                                            :hide-details="true"
                                                            @update:model-value="
                                                                $nextTick(() =>
                                                                    onMetadataChange_amountData(
                                                                        subAmount,
                                                                        'grossAmount',
                                                                    ),
                                                                )
                                                            "
                                                            @mouseover="
                                                                highlightField(
                                                                    subAmount.grossAmount,
                                                                    true,
                                                                )
                                                            "
                                                            @mouseout="
                                                                highlightField(
                                                                    subAmount.grossAmount,
                                                                    false,
                                                                )
                                                            "
                                                            :color="
                                                                priceTextColor_amountData(
                                                                    subAmount,
                                                                    false,
                                                                )
                                                            "
                                                            v-model="subAmount.grossAmount.value"
                                                        >
                                                            <template v-slot:label>
                                                                TTC {{ index + 1 }}
                                                                <span
                                                                    v-if="
                                                                        confidence(
                                                                            subAmount.grossAmount,
                                                                        )
                                                                    "
                                                                >
                                                                    (
                                                                    <span
                                                                        :class="
                                                                            confidence(
                                                                                subAmount.grossAmount,
                                                                            ) > 80
                                                                                ? ''
                                                                                : 'text-red'
                                                                        "
                                                                        >{{
                                                                            `${confidence(
                                                                                subAmount.grossAmount,
                                                                            )}%`
                                                                        }}</span
                                                                    >)
                                                                </span>
                                                            </template>
                                                        </oss-text-field-filled>
                                                    </v-col>
                                                    <v-col class="py-1 pr-1" v-if="multiVat">
                                                        <v-select-filled
                                                            :items="
                                                                subAmount.sign === -1
                                                                    ? vatListDiscount
                                                                    : vatList
                                                            "
                                                            regular
                                                            :hide-details="true"
                                                            :color="
                                                                priceTextColor_amountData(
                                                                    subAmount,
                                                                    false,
                                                                )
                                                            "
                                                            @update:model-value="
                                                                $nextTick(() =>
                                                                    onVatRateChange(
                                                                        subAmount,
                                                                        $event,
                                                                    ),
                                                                )
                                                            "
                                                            @mouseover="
                                                                highlightField(
                                                                    subAmount.vatRate,
                                                                    true,
                                                                )
                                                            "
                                                            @mouseout="
                                                                highlightField(
                                                                    subAmount.vatRate,
                                                                    false,
                                                                )
                                                            "
                                                            :model-value="
                                                                subAmount.vatType
                                                                    ? subAmount.vatRate.value.toString() +
                                                                      subAmount.vatType
                                                                    : subAmount.vatRate.value.toString()
                                                            "
                                                            density="compact"
                                                            item-title="text"
                                                        >
                                                            <template v-slot:label>
                                                                %TVA {{ index + 1 }}
                                                                <span
                                                                    v-if="
                                                                        confidence(
                                                                            subAmount.vatRate,
                                                                        )
                                                                    "
                                                                >
                                                                    (<span
                                                                        :class="
                                                                            confidence(
                                                                                subAmount.vatRate,
                                                                            ) > 80
                                                                                ? ''
                                                                                : 'text-red'
                                                                        "
                                                                    >
                                                                        {{
                                                                            `${confidence(
                                                                                subAmount.vatRate,
                                                                            )}%`
                                                                        }} </span
                                                                    >)
                                                                </span>
                                                            </template>
                                                        </v-select-filled>
                                                    </v-col>
                                                    <v-col
                                                        :cols="getSubAmountAACol(subAmount)"
                                                        v-if="
                                                            multiAccountableAccount ||
                                                            subAmount.vatRate.value === 0
                                                        "
                                                        :class="`py-1 order-${placementAccountableAccount}`"
                                                        :key="refreshKeySubAmount"
                                                    >
                                                        <AccountableAccountVue
                                                            :inputStyle="'padding: 0px; margin: 0px;'"
                                                            :inAccountableAccountType="
                                                                getAccountableType(subAmount.type)
                                                            "
                                                            :companyId="companyId"
                                                            :document="document"
                                                            :showSuggestion="false"
                                                            :showDescription="true"
                                                            :showValidation="false"
                                                            :mandatory="false"
                                                            :hideDetails="true"
                                                            :editAccountableAccount="true"
                                                            :addInvoiceProduct="enableStock"
                                                            @close="closeAccountableAccount"
                                                            @select-accountableAccount="
                                                                setSubAmountAccountableAccount(
                                                                    subAmount,
                                                                    $event,
                                                                )
                                                            "
                                                            v-if="multiAccountableAccount"
                                                            :model-value="
                                                                subAmount.accountableAccount
                                                            "
                                                        />
                                                    </v-col>
                                                    <v-col
                                                        cols="4"
                                                        :class="`py-1 order-${placementAccountableAccount}`"
                                                        v-if="
                                                            subAmount.stockOperation &&
                                                            subAmount.stockOperation.stockProductId
                                                        "
                                                    >
                                                        <oss-text-field-filled
                                                            :hide-details="true"
                                                            :label="
                                                                subAmount.stockOperation
                                                                    .quantityName
                                                            "
                                                            class="ml-2 righted-input oss-dark"
                                                            v-model="
                                                                subAmount.stockOperation
                                                                    .productQuantity
                                                            "
                                                            :rules="[
                                                                (v) =>
                                                                    v >= 0 ||
                                                                    $t('settings.positiveNumber'),
                                                            ]"
                                                        >
                                                        </oss-text-field-filled>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col
                                                cols="1"
                                                class="d-flex align-center justify-center inline-icon flex-column"
                                            >
                                                <v-icon
                                                    color="secondary"
                                                    @click="toggleLink(subAmount)"
                                                    v-if="multiVat"
                                                >
                                                    {{ subAmount.link ? "$link" : "$link_off" }}
                                                </v-icon>
                                                <v-icon
                                                    color="secondary"
                                                    @click="removeSubAmount(index)"
                                                    v-if="
                                                        form &&
                                                        form.subAmounts &&
                                                        form.subAmounts.length > 2
                                                    "
                                                    size="small"
                                                    >$oss-trash
                                                </v-icon>
                                            </v-col>
                                            <v-col cols="12" class="pt-2">
                                                <v-divider />
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <v-row no-gutters id="PricesDocumentValidation">
                                        <v-col
                                            class="pr-1 py-2"
                                            v-if="subjectToVAT"
                                            style="z-index: inherit"
                                        >
                                            <oss-text-field-filled
                                                @update:model-value="
                                                    $nextTick(() =>
                                                        onMetadataChange_amountData(
                                                            form.single_prices.prices,
                                                            'netAmount',
                                                        ),
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(
                                                        form.single_prices.prices.netAmount,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.single_prices.prices.netAmount,
                                                        false,
                                                    )
                                                "
                                                :color="
                                                    priceTextColor_amountData(
                                                        form.single_prices.prices,
                                                        true,
                                                    )
                                                "
                                                :readonly="multiVat || multiAccountableAccount"
                                                regular
                                                dense
                                                :hide-details="true"
                                                data-cy="DocumentValidation-ht"
                                                v-model="form.single_prices.prices.netAmount.value"
                                            >
                                                <template v-slot:label>
                                                    HT
                                                    <span
                                                        v-if="
                                                            confidence(
                                                                form.single_prices.prices.netAmount,
                                                            )
                                                        "
                                                    >
                                                        (<span
                                                            :class="
                                                                confidence(
                                                                    form.single_prices.prices
                                                                        .netAmount,
                                                                ) > 80
                                                                    ? 'yellow_custom--text'
                                                                    : 'text-red'
                                                            "
                                                        >
                                                            {{
                                                                `${confidence(
                                                                    form.single_prices.prices
                                                                        .netAmount,
                                                                )}%`
                                                            }} </span
                                                        >)
                                                    </span>
                                                </template>
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col
                                            class="px-1 py-2"
                                            v-if="subjectToVAT"
                                            style="z-index: inherit"
                                        >
                                            <oss-text-field-filled
                                                @update:model-value="
                                                    $nextTick(() =>
                                                        onMetadataChange_amountData(
                                                            form.single_prices.prices,
                                                            'vatAmount',
                                                        ),
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(
                                                        form.single_prices.prices.vatAmount,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.single_prices.prices.vatAmount,
                                                        false,
                                                    )
                                                "
                                                :color="
                                                    priceTextColor_amountData(
                                                        form.single_prices.prices,
                                                        true,
                                                    )
                                                "
                                                :readonly="multiVat"
                                                regular
                                                dense
                                                :hide-details="true"
                                                data-cy="DocumentValidation-tva"
                                                v-model="form.single_prices.prices.vatAmount.value"
                                            >
                                                <template v-slot:label>
                                                    TVA
                                                    <span
                                                        v-if="
                                                            confidence(
                                                                form.single_prices.prices.vatAmount,
                                                            )
                                                        "
                                                    >
                                                        (<span
                                                            :class="
                                                                confidence(
                                                                    form.single_prices.prices
                                                                        .vatAmount,
                                                                ) > 80
                                                                    ? 'yellow_custom--text'
                                                                    : 'text-red'
                                                            "
                                                        >
                                                            {{
                                                                `${confidence(
                                                                    form.single_prices.prices
                                                                        .vatAmount,
                                                                )}%`
                                                            }} </span
                                                        >)
                                                    </span>
                                                </template>
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col class="px-1 py-2" style="z-index: inherit">
                                            <oss-text-field-filled
                                                @update:model-value="
                                                    $nextTick(() =>
                                                        onMetadataChange_amountData(
                                                            form.single_prices.prices,
                                                            'grossAmount',
                                                        ),
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(
                                                        form.single_prices.prices.grossAmount,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.single_prices.prices.grossAmount,
                                                        false,
                                                    )
                                                "
                                                :color="
                                                    priceTextColor_amountData(
                                                        form.single_prices.prices,
                                                        true,
                                                    )
                                                "
                                                :readonly="multiVat"
                                                regular
                                                dense
                                                :hide-details="true"
                                                data-cy="DocumentValidation-ttc"
                                                v-model="
                                                    form.single_prices.prices.grossAmount.value
                                                "
                                            >
                                                <template v-slot:label>
                                                    TTC
                                                    <span
                                                        v-if="
                                                            confidence(
                                                                form.single_prices.prices
                                                                    .grossAmount,
                                                            )
                                                        "
                                                    >
                                                        (<span
                                                            :class="
                                                                confidence(
                                                                    form.single_prices.prices
                                                                        .grossAmount,
                                                                ) > 80
                                                                    ? 'yellow_custom--text'
                                                                    : 'text-red'
                                                            "
                                                        >
                                                            {{
                                                                `${confidence(
                                                                    form.single_prices.prices
                                                                        .grossAmount,
                                                                )}%`
                                                            }} </span
                                                        >)
                                                    </span>
                                                </template>
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col
                                            class="px-1 py-2"
                                            v-if="subjectToVAT"
                                            style="z-index: inherit"
                                        >
                                            <v-select-filled
                                                :items="vatList"
                                                regular
                                                :hide-details="true"
                                                v-show="!multiVat"
                                                item-title="text"
                                                :color="
                                                    priceTextColor_amountData(
                                                        form.single_prices.prices,
                                                        true,
                                                    )
                                                "
                                                @update:model-value="
                                                    $nextTick(() =>
                                                        onVatRateChange(
                                                            form.single_prices.prices,
                                                            $event,
                                                        ),
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(
                                                        form.single_prices.prices.vatRate,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.single_prices.prices.vatRate,
                                                        false,
                                                    )
                                                "
                                                data-cy="DocumentValidation-tvaPercentage"
                                                :model-value="
                                                    form.single_prices.prices.vatType
                                                        ? form.single_prices.prices.vatRate.value.toString() +
                                                          form.single_prices.prices.vatType
                                                        : form.single_prices.prices.vatRate.value.toString()
                                                "
                                            >
                                                <template v-slot:label>
                                                    %TVA
                                                    <span
                                                        v-if="
                                                            confidence(
                                                                form.single_prices.prices.vatRate,
                                                            )
                                                        "
                                                        data-cy="DocumentValidation-%tva"
                                                    >
                                                        (<span
                                                            :class="
                                                                confidence(
                                                                    form.single_prices.prices
                                                                        .vatRate,
                                                                ) > 80
                                                                    ? 'yellow_custom--text'
                                                                    : 'text-red'
                                                            "
                                                        >
                                                            {{
                                                                `${confidence(
                                                                    form.single_prices.prices
                                                                        .vatRate,
                                                                )}%`
                                                            }} </span
                                                        >)
                                                    </span>
                                                </template>
                                            </v-select-filled>
                                        </v-col>
                                        <v-col
                                            cols="1"
                                            class="pa-0 py-2 d-flex align-center justify-center"
                                            style="z-index: inherit"
                                        >
                                            <div class="inline-icon">
                                                <v-btn-icon
                                                    :icon="
                                                        form.allPricesValidated
                                                            ? '$oss-circle-check'
                                                            : '$oss-circle-uncheck'
                                                    "
                                                    @click="onPricesValidation()"
                                                    :color="
                                                        form.allPricesValidated ? 'primary' : 'red'
                                                    "
                                                    data-cy="DocumentValidation-valid"
                                                    size="small"
                                                >
                                                </v-btn-icon>
                                                <v-icon
                                                    color="secondary"
                                                    @click="toggleLink(form.single_prices.prices)"
                                                    v-if="!multiVat"
                                                    >{{
                                                        form.single_prices.prices.link
                                                            ? "$link"
                                                            : "$link_off"
                                                    }}</v-icon
                                                >
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <!-- <template
                                        v-if="
                                            vatSumAmounts &&
                                            vatSumAmounts.length !== 1 &&
                                            (!form.subAmount ||
                                                vatSumAmounts.length !== form.subAmount.length) &&
                                            subjectToVAT
                                        "
                                    >
                                        <v-row
                                            no-gutters
                                            v-for="(vat, index) in vatSumAmounts"
                                            :key="index"
                                        >
                                            <v-col cols="3">
                                                {{
                                                    newCommonFormatCurrency(
                                                        vat.netAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </v-col>
                                            <v-col cols="3">
                                                {{
                                                    newCommonFormatCurrency(
                                                        vat.vatAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </v-col>
                                            <v-col cols="3">
                                                {{
                                                    newCommonFormatCurrency(
                                                        vat.grossAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </v-col>
                                            <v-col cols="3">
                                                {{
                                                    vat.vatRate !== "custom"
                                                        ? vat.vatRate + " %"
                                                        : "-"
                                                }}
                                            </v-col>
                                        </v-row>
                                    </template> -->
                                    <v-row no-gutters v-if="showDeposit" class="flex-nowrap">
                                        <v-col
                                            cols="5"
                                            class="pl-1 d-flex align-center flex-grow-1 flex-shrink-0"
                                            style="max-width: 100%"
                                        >
                                            <v-switch
                                                v-model="withDeposit"
                                                :label="'Consigne'"
                                                hide-details
                                                class="my-0 ml-2"
                                                data-cy="DocumentValidation-order"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="7"
                                            class="d-flex align-center flex-grow-0 flex-shrink-1"
                                        >
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        class="d-flex"
                                        v-if="showDeposit && withDeposit"
                                    >
                                        <v-col cols="4" class="pa-1">
                                            <oss-text-field-filled
                                                v-model="deposit.amountSigned1"
                                                label="Consigne"
                                                regular
                                                dense
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col cols="4" class="pa-1">
                                            <oss-text-field-filled
                                                v-model="deposit.amountSigned2"
                                                label="Déconsigne"
                                                regular
                                                dense
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col cols="4" class="pa-1">
                                            <oss-text-field-filled
                                                label="TTC"
                                                regular
                                                dense
                                                content-class="mr-1"
                                                suffix="&#x20ac;"
                                                hide-details
                                                readonly
                                                :model-value="depositGrossAmountSigned"
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        no-gutters
                                        class="flex-nowrap py-2 pt-3"
                                        v-if="
                                            !isBankTransactionReceipt &&
                                            document &&
                                            document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        "
                                    >
                                        <v-col
                                            cols="7"
                                            class="pl-1 d-flex align-center flex-grow-1 flex-shrink-0"
                                            style="max-width: 100%"
                                        >
                                            <v-switch
                                                v-model="withSubGrossAmounts"
                                                :label="
                                                    isAccountingUser
                                                        ? 'Payer en plusieurs fois / * comptes de tiers'
                                                        : 'Payer en plusieurs fois'
                                                "
                                                class="py-0 my-0 pl-2"
                                                @change="onActiveSubGrossAmount()"
                                                hide-details
                                                data-cy="DocumentValidation-pay"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="5"
                                            class="d-flex align-center flex-grow-0 flex-shrink-1"
                                        >
                                            <v-divider />
                                        </v-col>
                                        <v-col
                                            class="justify-end align-center flex-grow-0 flex-shrink-1"
                                            v-if="withSubGrossAmounts"
                                        >
                                            <v-btn
                                                size="x-small"
                                                @click="addNewSubGrossAmount()"
                                                date-cy="DocumentValidation-add"
                                                icon="$add"
                                            >
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters v-if="withSubGrossAmounts">
                                        <v-col cols="12">
                                            <v-row
                                                no-gutters
                                                v-for="(
                                                    subGrossAmount, index
                                                ) of form.subGrossAmounts"
                                                :key="index"
                                            >
                                                <v-col class="mb-1">
                                                    <oss-text-field-filled
                                                        v-model="subGrossAmount.amount"
                                                        label="Montant"
                                                        regular
                                                        content-class="mr-1"
                                                        hide-details
                                                    />
                                                </v-col>
                                                <v-col
                                                    cols="5"
                                                    class="mb-1 pl-1"
                                                    v-if="isAccountingUser"
                                                >
                                                    <AccountableAccountVue
                                                        :inputStyle="'padding: 0px; margin: 0px;'"
                                                        :companyId="companyId"
                                                        :showSuggestion="false"
                                                        :showDescription="true"
                                                        :showValidation="false"
                                                        :mandatory="false"
                                                        :hideDetails="true"
                                                        :needValidation="false"
                                                        :editAccountableAccount="true"
                                                        :excludesAccountableAccount="[
                                                            '421000',
                                                            '425000',
                                                            '455000',
                                                            '455100',
                                                            '467000',
                                                            '467100',
                                                        ]"
                                                        @close="closeAccountableAccount"
                                                        @select-accountableAccount="
                                                            setAccountableAccountSubGrossAmount(
                                                                subGrossAmount,
                                                                $event,
                                                            )
                                                        "
                                                        :model-value="
                                                            subGrossAmount.accountableAccount
                                                        "
                                                    />
                                                </v-col>
                                                <v-col cols="4" class="pl-1 mb-1">
                                                    <oss-date-picker-filled
                                                        v-model="subGrossAmount.dueDate"
                                                        label="Échéance"
                                                        :textFieldReadOnly="false"
                                                        :notRequired="true"
                                                    />
                                                </v-col>
                                                <v-col
                                                    cols="1"
                                                    class="d-flex align-center justify-center"
                                                >
                                                    <v-btn-trash
                                                        v-if="form.subGrossAmounts.length > 1"
                                                        @click="removeSubGrossAmount(index)"
                                                        data-cy="DocumentValidation-trash"
                                                        size="small"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters class="py-2" v-if="showAudit">
                                        <v-col
                                            cols="1"
                                            class="d-flex align-center flex-grow-1 flex-shrink-0"
                                            style="max-width: 100%"
                                        >
                                            Révision comptable
                                        </v-col>
                                        <v-col
                                            cols="11"
                                            class="d-flex align-center flex-grow-0 flex-shrink-1"
                                        >
                                            <v-divider />
                                        </v-col>
                                        <v-col
                                            v-if="
                                                tooltipDocumentAdjustmentBtn ===
                                                'Exercice comptable clôturé'
                                            "
                                            cols="auto"
                                            class="px-2"
                                        >
                                            <span class="text-red">
                                                {{ tooltipDocumentAdjustmentBtn }}
                                            </span>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters v-if="showAudit">
                                        <v-col>
                                            <DocumentAuditActions
                                                :companyId="companyId"
                                                :document="document"
                                                :documentId="document.id"
                                                :documentAccountingPeriod="documentAccountingPeriod"
                                                @goToWindowStep10="openWindowStep10"
                                                @goToWindowStep0="setWindowStep"
                                            />
                                            <!-- @back="windowStep = 0" -->
                                            <!-- @goToWindowStep20="openWindowStep20" -->
                                            <!-- // ** fixedAssets are not opened in window
                                                // ** they will be routed in DocumentAuditActions with openFixedAssets() -->
                                        </v-col>
                                    </v-row>
                                    <!-- // ** STOCK OPERATIONS -->
                                    <v-row no-gutters class="py-2 pt-3" v-if="enableStock">
                                        <v-col
                                            cols="1"
                                            class="pl-1 d-flex align-center pr-3 flex-grow-1 flex-shrink-0"
                                            style="max-width: 100%"
                                        >
                                            Stocks
                                        </v-col>
                                        <v-col
                                            cols="11"
                                            class="d-flex align-center flex-grow-0 flex-shrink-1"
                                        >
                                            <v-divider />
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters v-if="enableStock">
                                        <v-col cols="12" class="py-1 mb-2">
                                            <v-card
                                                class="default_card_wm mx-auto pt-2"
                                                style="
                                                    background: #fff !important;
                                                    border: solid rgba(0, 0, 0, 0.12) 1px;
                                                    box-shadow: none;
                                                "
                                            >
                                                <v-card-title primary-title class="py-0">
                                                    <v-row no-gutters>
                                                        <v-col cols="auto" class="pr-2">
                                                            <span> Opérations de stock </span>
                                                        </v-col>
                                                        <v-spacer />
                                                        <v-col
                                                            cols="auto"
                                                            class="d-flex justify-end"
                                                        >
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <div v-bind="props">
                                                                        <v-btn-icon
                                                                            icon="$oss-edit"
                                                                            elevation="0"
                                                                            class="my-0"
                                                                            @click="windowStep = 11"
                                                                            size="x-small"
                                                                        />
                                                                    </div>
                                                                </template> </v-tooltip
                                                        ></v-col>
                                                    </v-row>
                                                </v-card-title>
                                            </v-card>
                                        </v-col>
                                    </v-row>

                                    <!-- // ** CUT-OFF -->
                                    <v-row
                                        no-gutters
                                        class="pt-1 pb-0"
                                        v-if="!accountingLinesLocked && showDetail"
                                    >
                                        <v-col cols="12">
                                            <v-row no-gutters class="py-2 align-center">
                                                <v-col
                                                    cols="1"
                                                    class="pl-1 pr-3 flex-grow-1 flex-shrink-0"
                                                    style="max-width: 100%"
                                                >
                                                    Détails
                                                </v-col>
                                                <v-col
                                                    cols="11"
                                                    class="pr-3 flex-grow-0 flex-shrink-1"
                                                >
                                                    <v-divider />
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col cols="12" class="py-2 mb-2">
                                            <accounting-item-static
                                                :companyId="companyId"
                                                :documentId="document.id"
                                                @update="startToBeDoneIfNecessary"
                                                mode="Payment"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-window-item>
                            <v-window-item :value="1">
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <v-btn-back @click.stop="windowStep = 0" />
                                    </v-col>
                                    <v-col cols="12">
                                        <CompaniesTable
                                            :showGenericCompany="document.type !== 'SALES_INVOICE'"
                                            :showCustomerCompanies="
                                                document.type === 'SALES_INVOICE'
                                            "
                                            :showSupplierCompanies="
                                                document.type !== 'SALES_INVOICE'
                                            "
                                            :foundCompanies="foundCompanies"
                                            :showExistingCompanies="false"
                                            :company="
                                                document.thirdPartyCompany
                                                    ? document.thirdPartyCompany.name
                                                    : ''
                                            "
                                            :siret="
                                                document.thirdPartyCompany &&
                                                document.thirdPartyCompany.siret
                                                    ? document.thirdPartyCompany.siret
                                                    : ''
                                            "
                                            :siren="
                                                document.thirdPartyCompany &&
                                                document.thirdPartyCompany.siren
                                                    ? document.thirdPartyCompany.siren
                                                    : ''
                                            "
                                            :vatNumber="
                                                document.thirdPartyCompany &&
                                                document.thirdPartyCompany.vatNumber
                                                    ? document.thirdPartyCompany.vatNumber
                                                    : ''
                                            "
                                            :parentCompanyId="
                                                selectedCompany ? selectedCompany.id : ''
                                            "
                                            :wizardMode="true"
                                            :canSelectInactiveCompanies="true"
                                            listHeight="calc(100vh - 315px)"
                                            @select-company="_companySelected"
                                        />
                                    </v-col>
                                </v-row>
                            </v-window-item>

                            <!-- // ** DocumentAdjustments -->
                            <v-window-item :value="10">
                                <v-row no-gutters>
                                    <v-col cols="12" v-if="auditChildren === 'DocumentAdjustments'">
                                        <DocumentAdjustments
                                            :companyId="companyId"
                                            :thirdPartyCompany="
                                                document.thirdPartyCompany
                                                    ? document.thirdPartyCompany
                                                    : ''
                                            "
                                            :document="document"
                                            :documentAcrStatus="documentAcrStatus"
                                            :documentAccountingPeriod="
                                                documentAccountingPeriod || undefined
                                            "
                                            :acKey="adjustmentAcKey"
                                            @back="windowStep = 0"
                                        >
                                        </DocumentAdjustments>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <v-window-item :value="11">
                                <v-row no-gutters>
                                    <v-col cols="12" v-if="true">
                                        <StockOperationDocumentEdition
                                            class="pa-0 ma-0"
                                            v-if="windowStep === 11"
                                            :companyId="companyId"
                                            :documentId="documentId"
                                            :document="document"
                                            @back="windowStep = 0"
                                        />
                                    </v-col>
                                </v-row>
                            </v-window-item>
                        </v-window>
                    </v-card-text>
                    <v-card-actions class="align-self-end" v-if="windowStep === 0">
                        <v-row no-gutters style="min-height: 32px">
                            <v-col
                                cols="12"
                                :class="{
                                    'd-flex': true,
                                    'justify-end': true,
                                    'align-center': true,
                                    'pr-15': openChat,
                                }"
                            >
                                <v-tooltip
                                    v-if="selectedCompany.solution !== 'MANAGEMENT'"
                                    location="top"
                                >
                                    <template v-slot:activator="{ props }">
                                        <v-btn
                                            @click="setToReuploadDocumentDialog = true"
                                            class="mr-1"
                                            :disabled="document.status === 'VALIDATED'"
                                            data-cy="DocumentValidation-documentPendingBTN"
                                            v-bind="props"
                                            icon="$hourglass_empty"
                                            variant="flat"
                                            size="x-small"
                                        >
                                        </v-btn>
                                    </template>
                                    <span>Document en attente</span>
                                </v-tooltip>
                                <oss-dialog
                                    v-model="setToReuploadDocumentDialog"
                                    title="Passer en attente"
                                    @valid="setToReuploadDocument()"
                                    prefixDataCy="DocumentValidation-documentPending"
                                    width="800px"
                                >
                                    <div class="text-center">Passer ce document en attente</div>
                                </oss-dialog>
                                <v-tooltip
                                    v-if="selectedCompany.solution !== 'MANAGEMENT'"
                                    location="top"
                                >
                                    <template v-slot:activator="{ props }">
                                        <v-btn-warning
                                            @click="setOpenChat('DENIED')"
                                            class="mr-1"
                                            :disabled="document.status === 'DENIED'"
                                            data-cy="DocumentValidation-reject"
                                            v-bind="props"
                                            variant="flat"
                                            size="x-small"
                                        >
                                        </v-btn-warning>
                                    </template>
                                    <span>Rejeter</span>
                                </v-tooltip>
                                <v-tooltip
                                    v-if="selectedCompany.solution !== 'MANAGEMENT'"
                                    location="top"
                                >
                                    <template v-slot:activator="{ props }">
                                        <v-btn
                                            @click="setOpenChat('INFORMATION_REQUEST')"
                                            class="mx-1"
                                            data-cy="DocumentValidation-question"
                                            v-bind="props"
                                            icon="$oss-chat"
                                            variant="flat"
                                            size="x-small"
                                        >
                                        </v-btn>
                                    </template>
                                    <span>Question</span>
                                </v-tooltip>
                                <DocumentValidationSpeedRun
                                    v-if="displayDocumentValidationSpeedRun(document.status)"
                                    v-model="lastDocumentValidationDone"
                                />
                                <div id="ValidDocumentValidation">
                                    <v-btn
                                        class="ml-1"
                                        @click="onCheckFormValidation()"
                                        :loading="loading"
                                        data-cy="DocumentValidation-valider"
                                        size="small"
                                        variant="flat"
                                        :disabled="disabledValidate || doublonLoading"
                                    >
                                        {{ validated ? "Validé" : "Valider" }}
                                        <v-icon v-show="validated">$check</v-icon>
                                    </v-btn>
                                </div>
                                <v-btn-prev
                                    :disabled="previousDisabled()"
                                    @click="previous()"
                                    v-if="mode != 'GeneralLedger' && mode !== 'Reconciliation'"
                                />
                                <v-btn-next
                                    :disabled="nextDisabled()"
                                    @click="next()"
                                    v-if="mode != 'GeneralLedger' && mode !== 'Reconciliation'"
                                />
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <oss-date-picker
            :hideActivator="true"
            :activate="dateDialog"
            @close="closeDateDialog()"
            v-model="date"
        >
        </oss-date-picker>

        <Chat
            v-if="openChat"
            v-bind:id="document.chat ? document.chat.id : ''"
            v-bind:inShowMessage="open_chat"
            v-bind:chatTitle="'Document'"
            v-bind:chatSubtitle="getChatSubTitle()"
            :showSmartChat="wishStatus !== 'DENIED'"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />
        <oss-dialog v-model="dialogChooseDownload" title="Télécharger le document" width="800px">
            Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté) ?

            <template v-slot:actions>
                <v-row no-gutters>
                    <v-col cols="6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="downloadFile(true)"
                            id="DownloadOriginalDocumentValidation"
                            size="x-large"
                            >Original</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-btn-primary rounded block @click="downloadFile(false)" size="x-large"
                            >Marqué</v-btn-primary
                        >
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
        <oss-dialog
            v-model="dialogSwitchToMiscellaneous"
            title="Passer le document en divers"
            @valid="switchToMiscellaneous"
            width="800px"
        >
            <h4>
                Si vous confirmez l'action, toutes les données comptables associés aux documents
                seront supprimées
            </h4>
        </oss-dialog>
        <oss-dialog
            v-model="analyseDocumentDialog"
            title="Relancer l'analyse du document"
            @valid="analyseDocument"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir relancer l'analyse ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="accountingLinesLockedDialog"
            title="Passer en écriture manuelle"
            @valid="lockAccountingLines"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="accountingLinesLockedLoading"
            width="800px"
        >
            <h4>
                Si vous confirmez l'action, vous pourrez modifier les écritures manuellement mais
                vous perdez les automatismes
            </h4>
        </oss-dialog>

        <!-- ** deleteOrphelinDocumentDialog -->
        <oss-dialog
            v-if="orphelinDepreciationAcrId && orphelinDepreciationAcrId.length"
            v-model="deleteOrphelinDocumentDialog"
            title="Supprimer le contrôle orphelin"
            :error="true"
            @valid="deleteAuditCheckResult(orphelinDepreciationAcrId)"
            :validTitle="'Valider la suppression des amortissements automatiques'"
            :validLoading="deleteOrphelinDocumentLoading"
            width="800px"
        >
            <template v-if="editionMessage && editionMessage.length">
                <div v-html="editionMessage" />
            </template>
        </oss-dialog>

        <!-- ** deleteDocumentDialog -->
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <template v-if="editionMessage && editionMessage.length">
                <div v-html="editionMessage" />
            </template>

            <!-- <h4 v-if="editionMessage" class="pb-4">
                    Veuillez supprimer le contrôle afin de déverrouiller le document
                </h4> -->
            <!-- <h4 v-else class="pb-4"> -->
            <h4 class="pb-4">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>

        <oss-dialog
            v-model="spreadPurchaseDialog"
            title="Etaler le montant sur plusieurs mois"
            @valid="spreadAmount"
            :validLoading="loading"
            :validDisabled="!spreadValid"
            width="800px"
        >
            <v-form v-model="spreadValid">
                <v-row>
                    <v-col cols="12">
                        Pour les charges supérieures à 1000 euros vous pouvez répartir le montant
                        sur plusieurs mois
                    </v-col>
                    <v-col cols="12">
                        <v-switch v-model="activateSpreadAmount" label="Etaler" />
                    </v-col>
                    <v-col cols="12" v-show="activateSpreadAmount">
                        <oss-date-picker
                            v-bind:label="$t('shared.spreadStartDate')"
                            v-model="spreadStartDate"
                            v-bind:minDate="spreadMinStartDate"
                            v-bind:maxDate="spreadMaxStartDate"
                            v-bind:type="'month'"
                            v-bind:format="'MM/YYYY'"
                        >
                        </oss-date-picker>
                    </v-col>
                    <v-col cols="12" mt-4 v-show="activateSpreadAmount">
                        <v-slider
                            v-model="spreadMounthCount"
                            :thumb-size="24"
                            thumb-label="always"
                            label="Nombre de mois"
                            min="2"
                            max="12"
                            show-ticks
                        />
                    </v-col>
                </v-row>
            </v-form>
        </oss-dialog>
        <oss-dialog
            v-model="cutDocumentDialog"
            title="Découpe de document"
            @valid="cutDocument()"
            width="800px"
        >
            <h4 class="text-center">Êtes-vous sûr(e) de vouloir découper ce document ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="confirmDoublonDialog"
            title="Confirmez la validation"
            @valid="onFormValidation()"
            prefixDataCy="DocumentValidation-documentPending"
            width="800px"
        >
            <div class="text-center">
                Il existe déjà une facture avec le même montant à la même date pour le même
                {{ document.type === "PURCHASE_INVOCE" ? "fournisseur" : "client" }}
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { groupBy, reduce, orderBy } from "lodash";
import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import {
    adjustmentsPurchasesConditions,
    adjustmentsSalesConditions,
} from "../../services/documentServices";
import _ from "lodash";

import { DocumentValidationInvoiceBase } from "./DocumentValidationInvoiceBase";
import AccountableAccountVue from "../AccountableAccount.vue";
import CompaniesTable from "../admin/CompaniesTable.vue";
import DocumentAuditActions from "./DocumentAuditActions.vue";
import DocumentAdjustments from "./DocumentAdjustments.vue";
import ossPdf from "./DocumentPDF.vue";
import AccountingItemStatic from "../AccountingItemStatic.vue";
import FreeTag from "../tag/FreeTag.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import StockOperationDocumentEdition from "../stock/StockOpDocumentEdition.vue";
import Chat from "../chat/Chat.vue";
import { DocumentMenu } from "./DocumentMenu.vue";

import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";

import SWITCH_DOCUMENT_MISCELLANEOUS from "../../graphql/document/SwitchDocumentToMiscellaneous.gql";
import LOCK_DOCUMENT_ACCOUNTINGLINES from "../../graphql/document/LockDocumentAccountingLines.gql";

import { Company, User } from "../../../../types";
import { getSiretValue } from "../../../src/services/companyServices";
import { Component, Vue, toNative } from "vue-facing-decorator";

import UPDATE_DOCUMENT_TYPE from "../../graphql/document/UpdateDocumentType.gql";
import emitter from "@/services/emitter";

import {
    MenuDisplayOptions,
    MenuDisplayZoomOptions,
    MenuDisplayOCROptions,
    MenuDisplayEditOptions,
    MenuDisplayDisplayModeOptions,
    MenuDisplayDotMenuOptions,
    MenuDisplayCutOptions,
    MenuDisplayRotationOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

import BobbeeImg from "../../assets/img/bobbee3d/bobbee3dTuto.png";

import DocumentValidationSpeedRun from "./DocumentValidationSpeedRun.vue";
import { isNoValidatedDocument } from "./DocumentValidationSpeedRun.helper";

@Component({
    components: {
        AccountableAccountVue,
        CompaniesTable,
        DocumentAuditActions,
        DocumentAdjustments,
        ossPdf,
        AccountingItemStatic,
        FreeTag,
        UsersActivitiesHistory,
        StockOperationDocumentEdition,
        Chat,
        DocumentValidationSpeedRun,
        DocumentMenu,
    },
    emits: ["reloadDocument"],
})
export class DocumentValidation extends DocumentValidationInvoiceBase {
    windowStep = 0;

    dialogSwitchToMiscellaneous = false;

    showAccountingLines = false;

    cutDocumentDialog: boolean = false;

    accountingItemMenu = false;

    tooltipDocumentAdjustmentBtn: String = "";

    setToReuploadDocumentDialog = false;

    auditChildren: string = "";
    documentAcrStatus: string = "";
    adjustmentAcKey: string = "";

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    // @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    // accountingPeriod:any

    get documentMenuOptionsZoomButton(): MenuDisplayZoomOptions {
        const zoomButton: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomButton.isDisplay = !this.showAccountingLines && !this.displayActivity && !this.isPDF;
        zoomButton.isZoomInDisabled = this.zoomManager.disableZoomIn();
        zoomButton.isZoomOutDisabled = this.zoomManager.disableZoomOut();
        zoomButton.isResetZoomDisabled = this.zoomManager.disableResetZoom();

        return zoomButton;
    }

    get documentMenuOptionsOCRButton(): MenuDisplayOCROptions {
        const ocrButton: MenuDisplayOCROptions = {
            ...documentMenuDisplayOptionsDefaultScheme.OCRButtons,
        };

        ocrButton.isDisplay =
            !this.showAccountingLines && !this.displayActivity && !!this.document.signedUrlOCR;
        ocrButton.disabled = this.zoomManager.disableResetZoom();
        ocrButton.isLoading = this.ocrLoading;

        return ocrButton;
    }

    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        const rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };

        rotationButton.isDisplay =
            !this.showAccountingLines && !this.displayActivity && !this.isPDF;

        return rotationButton;
    }

    get documentMenuOptionsEditButton(): MenuDisplayEditOptions {
        const editButton: MenuDisplayEditOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.editButton,
        };

        editButton.isDisplay = this.showAccountingLines && !this.isIncomingOutgoingPayment;

        return editButton;
    }

    get documentMenuOptionsCutButton(): MenuDisplayCutOptions {
        const cutButton: MenuDisplayCutOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.cutButton,
        };

        cutButton.isDisplay =
            this.document.status !== "VALIDATED" &&
            this.document.status !== "DELETED" &&
            this.document.status !== "DENIED";
        cutButton.disabled = false;

        return cutButton;
    }
    get documentMenuOptionsDisplayMode(): MenuDisplayDisplayModeOptions {
        const displayMode: MenuDisplayDisplayModeOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.displayModeButtons,
        };

        displayMode.isDisplay =
            !this.isIncomingOutgoingPayment &&
            this.document.status === "VALIDATED" &&
            this.document.type !== "EXPENSE_REPORT_DOCUMENT";
        displayMode.isAccountingLineModeDisplay = this.document.accountingLines?.length;
        displayMode.isPDFModeDisplay = true;

        return displayMode;
    }

    get documentMenuOptionsDotMenu(): MenuDisplayDotMenuOptions {
        const dotMenu: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenu.isDisplay = true;

        dotMenu.document.isDisplay =
            this.isAccountingUser && this.document.type !== "EXPENSE_REPORT_DOCUMENT";
        dotMenu.document.title = "Document";

        dotMenu.accountingLine.isDisplay =
            this.isAccountingUser &&
            this.document.type !== "EXPENSE_REPORT_DOCUMENT" &&
            this.document.accountingLines?.length;
        dotMenu.accountingLine.title = this.isIncomingOutgoingPayment
            ? "Détail"
            : "Écritures comptables";

        dotMenu.download.isDisplay =
            !this.showAccountingLines && !this.displayActivity && !!this.document.original;
        dotMenu.download.title = "Télécharger";

        dotMenu.cut.isDisplay = this.document.status !== "VALIDATED";
        dotMenu.cut.title = "Découpe de document";

        dotMenu.edit.isDisplay =
            !this.isIncomingOutgoingPayment && this.document.type !== "EXPENSE_REPORT_DOCUMENT";
        dotMenu.edit.title = "Écritures manuelles";

        dotMenu.analyse.isDisplay = this.restartAnalysis;
        dotMenu.analyse.title = "Relancer l'analyse";

        dotMenu.activity.isDisplay = this.isAccountingUser;
        dotMenu.activity.title = "Afficher l'activité";

        dotMenu.delete.isDisplay = true;
        dotMenu.delete.title = "Supprimer";
        dotMenu.delete.HTMLMessage = this.editionMessage;
        dotMenu.delete.disabled = this.disabledDelete;

        return dotMenu;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = {
            ...documentMenuDisplayOptionsDefaultScheme,
            dotMenu: {
                ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
            },
        };

        documentMenuOption.zoomButtons = this.documentMenuOptionsZoomButton;
        documentMenuOption.OCRButtons = this.documentMenuOptionsOCRButton;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.isSelectedText = !this.showAccountingLines && !this.displayActivity;
        documentMenuOption.cutButton = this.documentMenuOptionsCutButton;
        documentMenuOption.editButton = this.documentMenuOptionsEditButton;
        documentMenuOption.displayModeButtons = this.documentMenuOptionsDisplayMode;
        documentMenuOption.dotMenu = this.documentMenuOptionsDotMenu;

        return documentMenuOption;
    }

    get formattedDate() {
        return this.formatObjectDate(this.form.date);
    }

    set formattedDate(value) {
        this.onDateChange(this.form.date, "date", value);
    }

    get date() {
        if (!this.form || !this.form.date || !this.form.date.value) return "";
        return this.form.date.value;
    }

    set date(value) {
        if (this.form && this.form.date) {
            this.form.date.value = value;
            if (value) {
                this.form.date.validated = true;
            }
        }
    }

    get invoiceNumber() {
        return this.form["invoiceNumber"].value;
    }

    set invoiceNumber(data) {
        this.onDateChange(this.form["invoiceNumber"], "invoiceNumber", data);
    }

    get vatSumAmounts() {
        let sorted: any = Object.values(groupBy(this.form.subAmounts, (x) => x.vatRate.value));
        sorted = sorted.flatMap((x) => ({
            vatRate: x[0].vatRate.value,
            grossAmount: reduce(
                x,
                function (sum, n) {
                    return sum + n.grossAmount.value;
                },
                0,
            ),
            netAmount: reduce(
                x,
                function (sum, n) {
                    return n.type === "DISCOUNT"
                        ? sum - n.netAmount.value
                        : sum + n.netAmount.value;
                },
                0,
            ),
            vatAmount: reduce(
                x,
                function (sum, n) {
                    return n.type === "DISCOUNT"
                        ? sum - n.vatAmount.value
                        : sum + n.vatAmount.value;
                },
                0,
            ),
        }));
        sorted = orderBy(sorted, ["vatRate"], ["asc"]);
        return sorted;
    }

    get placementAccountableAccount() {
        if (!this.subjectToVAT || (this.multiAccountableAccount && !this.multiVat)) {
            return "last";
        }
        return "first";
    }

    /**
     *
     * Update the type of the document to allow for a document split, then on completion,
     * triggers a refetch of the `dbDocuments` query to update the page
     *
     * @async
     * @returns {Promise<void>} Resolves when the mutation and refetch are complete.
     */
    async cutDocument(): Promise<void> {
        this.$apollo
            .mutate({
                mutation: UPDATE_DOCUMENT_TYPE,
                variables: {
                    id: this.document.id,
                    type: "UNKNOWN",
                    status: "UPLOADED",
                    owner: this.currentAccountUser.id
                        ? { connect: { id: this.currentAccountUser.id } }
                        : undefined,
                },
            })
            .then(async () => {
                this.$emit("reloadDocument");
            });
    }

    getSubAmountAACol(subAmount) {
        if (this.placementAccountableAccount === "last") {
            if (subAmount.stockOperation?.stockProductId) {
                return "4";
            }
            return "6";
        }
        if (subAmount.stockOperation?.stockProductId) {
            return "8";
        }
        return "12";
    }

    get depositGrossAmountSigned() {
        return mathFix(this.grossAmountSigned);
    }

    closeDateDialog() {
        this.dateDialog = false;
    }

    beforeMount() {
        this.svgSuffix = "document-validation";
        emitter.$on("launchTuto", this.startTuto);
    }

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.users) {
                    this.currentAccountUsers = data.users;
                    this.updateCurrentAccountUser();
                }
            }
        },
    })
    currentAccountUsers: User[] = [];

    getUsers() {
        return this.currentAccountUsers;
    }

    _companySelected(obj: Company) {
        this.companySelected(obj);
        this.windowStep = 0;
    }

    onTypeChange(type) {
        //this.initializeUserActivity("UPDATE")
        if (type === "MISCELLANEOUS") {
            this.dialogSwitchToMiscellaneous = true;
        } else {
            this.document.type = type;
        }
    }

    async switchToMiscellaneous() {
        const newDocument: any = await this.$apollo.mutate({
            mutation: SWITCH_DOCUMENT_MISCELLANEOUS,
            variables: {
                documentId: this.document.id,
                type: "MISCELLANEOUS",
            },
        });
        this.dialogSwitchToMiscellaneous = false;

        this.$router.replace({
            name: "document",
            params: {
                companyId: this.selectedCompany.id,
                id: newDocument.data.updateDocumentAsMiscellenous.id,
            },
        });
    }

    getAccountableType(type) {
        if (this.document.type === "PURCHASE_INVOICE") {
            switch (type) {
                case "DISCOUNT":
                    return "DiscountPurchase";
                case "TRANSPORTATION":
                    return "TransportationPurchase";
            }
        }
        if (this.document.type === "SALES_INVOICE") {
            switch (type) {
                case "DISCOUNT":
                    return "DiscountSales";
                case "TRANSPORTATION":
                    return "TransportationSales";
            }
        }
        return null;
    }

    setAccountableAccountSubGrossAmount(subAmount, accountableAccount) {
        subAmount.accountableAccount = accountableAccount.accountableAccount;
    }

    refreshKeySubAmount: number = 0;

    setSubAmountAccountableAccount(subAmount, data) {
        if (
            data.accountableAccount.name.startsWith("709") ||
            data.accountableAccount.name.startsWith("609")
        ) {
            subAmount.sign = -1;
        } else {
            subAmount.sign = 1;
        }
        subAmount.accountableAccount = data.accountableAccount;
        if (data.accountableAccount.invoiceProduct) {
            let quantities = [];
            if (data.accountableAccount.invoiceProduct.data?.quantities?.length) {
                quantities = data.accountableAccount.invoiceProduct.data.quantities.map((q) => ({
                    quantityName: q.quantityName,
                    quantity: 0,
                }));
            }
            if (subAmount.stockOperation) {
                subAmount.stockOperation.stockProductId = data.accountableAccount.invoiceProduct.id;
                subAmount.stockOperation.unitQuantity =
                    data.accountableAccount.invoiceProduct.unitQuantity || 1;
                subAmount.tagId = data.accountableAccount.invoiceProduct.tag
                    ? data.accountableAccount.invoiceProduct.tag.id
                    : undefined;
                subAmount.stockOperation.data = { quantities: quantities };
            } else {
                subAmount.stockOperation = {
                    stockProductId: data.accountableAccount.invoiceProduct.id,
                    unitQuantity: data.accountableAccount.invoiceProduct.unitQuantity || 1,
                    productQuantity: 0,
                    quantity: 0,
                    tagId: data.accountableAccount.invoiceProduct.tag
                        ? data.accountableAccount.invoiceProduct.tag.id
                        : undefined,
                    data: { quantities: quantities },
                };
            }
        } else {
            subAmount.stockOperation = null;
        }
        this.refreshKeySubAmount++;
    }

    setWindowStep() {
        this.windowStep = 0;
    }

    openWindowStep10(data) {
        this.auditChildren = data.auditChildren;
        this.documentAcrStatus = data.documentAcrStatus;
        this.adjustmentAcKey = data.adjustmentAcKey;
        this.windowStep = data.value;
    }

    // ** fixedAssets are not opened in window
    // ** they will be routed in DocumentAuditActions with openFixedAssets()
    // openWindowStep20(data) {
    //     this.auditChildren = data.auditChildren
    //     this.documentAcrStatus = data.documentAcrStatus
    //     this.adjustmentAcKey = data.acKey
    //     this.windowStep = data.value
    // }

    // get documentAcrStatus() {
    //     if (this.document && this.document.auditCheckResults && this.document.auditCheckResults.length) {
    //         let acr

    //         if (this.acKey.length) {
    //             acr = this.document.auditCheckResults.find(acr => (acr as any).auditCheck.key === this.acKey)
    //         }

    //         if (acr && Object.keys(acr).length) {
    //             return acr.status
    //         }
    //     }
    //     return ""
    // }

    get having6or7AccountableAccounts() {
        if (
            this.document &&
            this.document.accountingLines &&
            this.document.accountingLines.length
        ) {
            const having6or7AA = this.document.accountingLines.find(
                (al) => adjustmentsPurchasesConditions(al) || adjustmentsSalesConditions(al),
            );

            if (having6or7AA) {
                return true;
            }
            return false;
        }
        // ** no accountingLines ?
        return false;
    }

    onActiveSubGrossAmount() {
        if (this.withSubGrossAmounts && !this.form?.subGrossAmounts?.length) {
            this.addNewSubGrossAmount();
            this.form.subGrossAmounts[0].amount = this.document.grossAmount;
        }
    }

    //
    // Manual AccountingLine
    //
    accountingLinesLockedDialog = false;
    accountingLinesLockedLoading = false;

    async lockAccountingLines() {
        this.accountingLinesLockedLoading = true;
        await this.$apollo.mutate({
            mutation: LOCK_DOCUMENT_ACCOUNTINGLINES,
            variables: {
                documentId: this.document.id,
            },
        });
        // if (docResult) {
        //     try {
        //         await this.createUserActivity(this.document.id, "UPDATE");
        //     } catch (e) {
        //         console.error(e);
        //     }
        // }
        this.startToBeDoneIfNecessary();
        this.accountingLinesLockedLoading = false;
        this.accountingLinesLockedDialog = false;
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: null,
                title: "Validation des factures",
                pages: [
                    {
                        text: "La validation des factures se fait en plusieurs étapes.",
                        img: BobbeeImg,
                        outed: true,
                    },
                ],
            },
            {
                ref: document.getElementById("InvoiceDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: "Dans un premier temps, bobbee analyse votre facture ...",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("FormDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: "... et remplit automatiquement le formulaire avec les données qu'il a détecté.",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("ThirdCompanyDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: `Vérifiez ${
                            this.document.type === "PURCHASE_INVOICE"
                                ? "le fournisseur"
                                : "le client"
                        }`,
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("NameDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: "Ajoutez un nom à votre document si vous le souhaitez.",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("TypeDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: "Vérifiez son type.",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("CreditNoteDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: `Activer ce mode si le document est un avoir ${
                            this.document.type === "PURCHASE_INVOICE" ? "d'achat" : "de vente"
                        }`,
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("MultiVATDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: "Activez cette option si le document contient plusieurs lignes de TVA.",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("MultiAccountableAccountDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: "Activez cette option si le document doit être rattaché a plusieurs comptes comptable.",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("PricesDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: "Vérifiez les montants trouvés par bobbee",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("ValidDocumentValidation"),
                title: "Validation des factures",
                pages: [
                    {
                        text: "Et vous pouvez valider votre facture.",
                        position: "top",
                        align: "end",
                    },
                ],
            },
        ]);
    }

    get showAudit() {
        if (this.isAccountingUser) {
            if (this.document.status === "VALIDATED") {
                return true;
            }
        }
        return false;
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    /**
     * Updates the rotation of the document PDF, used for update event
     *
     * @param {number} newRotation - The new rotation angle for the document PDF
     */
    updateRotation(newRotation: number) {
        this.documentPdfRotation = newRotation;
    }

    displayDocumentValidationSpeedRun(documentStatus: string) {
        return isNoValidatedDocument(documentStatus);
    }

    confirmDoublonDialog: boolean = false;

    onCheckFormValidation() {
        if (this.doublonCount) {
            this.confirmDoublonDialog = true;
        } else {
            this.onFormValidation();
        }
    }
}

export default toNative(DocumentValidation);
</script>

<style lang="scss" scoped>
.subAmountLine {
    transition: 0.5s;
}

.subAmountLine:hover {
    background: #f6f6f6;
    transition: 0.5s;
}

.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

polygon.error {
    fill: rgba(255, 0, 0, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
